// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2589":"d6fdf0fb","3532":"887972a4","7116":"07626bd9","9103":"b9ea4917","9603":"74fab3b8"}[chunkId] + ".css";
};